var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "base-vimeo-video",
      class: { "base-vimeo-video--landscape": !_vm.isBroken }
    },
    [
      _c("video", {
        attrs: {
          src: _vm.videoSrc,
          poster: _vm.videoPoster,
          autoplay: _vm.videoAutoplay,
          loop: _vm.videoLoop,
          preload: "none",
          playsinline: ""
        },
        domProps: { muted: _vm.videoMuted }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }